import { connect } from "react-redux";
var Glyphicon = require("components/utility/icons/Glyphicon");

var Modal = require("components/utility/AltModal");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");
var CurrentUser = require("lib/account/CurrentUser");
var TextTypes = require("lib/academic/TextTypes")

var ReadingActions = require("lib/actions/ReadingActions");

require("reading/books/book_text_variety.scss");

@connect(
	(state, props) => ({}),
	(dispatch, props) => ({
		updateBook: (textVariety) => {
			var user = CurrentUser.get()
			var overrideData = {
				instance_id: props.book.text_id,
				instance_type: "book",
				attribute_name: "text_variety",
				value: textVariety,
				user_id: user.id,
				user_role: user.role,
			}
			var bookUpdate = { text_variety: textVariety } 
			dispatch(ReadingActions.createOverrideUpdateBook({ override: overrideData, update: bookUpdate })).then((response) => {
				if (props.onSelect) {
					props.onSelect(overrideData) 
				}
			})
		}
	})
)
class BookTextVariety extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {edit: false}
	}

	onCancel() {
		this.props.reset();
	}

	onSelect(textVariety,e) {
		$wr.nope(e)
		this.props.updateBook(textVariety);
		if (this.props.onSubmit) {
			this.props.onSubmit(this.props.book)
		} else {
			this.setState({edit: false})
		}
		if (this.props.selectForActivity) {
			this.props.fetchbook;
		}
	}

	renderModalDisplay() {
		return (
			<div className="bookTextVariety text-center">
				How would you describe this book?
				<div className="row">
					<div className="col-sm-5 text-center optionContainer">
						<button className="btn btn-default" onClick={this.onSelect.bind(this,"fiction")}>Fiction</button>
						<div>This book is about imaginary events or people.</div>
					</div>
					<div className="col-sm-2 text-center seperator">
						OR
					</div>
					<div className="col-sm-5 text-center optionContainer">
						<button className="btn btn-default" onClick={this.onSelect.bind(this,"non-fiction")}>Non Fiction</button>
						<div>This book is about real events, facts or people.</div>
					</div>
				</div>
			</div>
		);
	}
	triggerEdit(e) {
		$wr.nope(e)
		this.setState({edit: !this.state.edit})
	}
	renderCellDisplay() {
		if (this.state.edit) {
			var fictionClass = ""
			var nonFictionClass = ""

			if (this.props.book.text_variety && TextTypes["Varieties"]["TYPES"][this.props.book.text_variety]) {
				var textVariety = TextTypes["Varieties"]["TYPES"][this.props.book.text_variety].abbreviation;
				
				if (textVariety == "F") {
					var fictionClass = "selected"
				} else {
					var nonFictionClass = "selected"
				}
			}
			var link = (
				<div className="selection">
					<a href="#" className={ fictionClass } onClick={ this.onSelect.bind(this, "fiction") }>F</a> |
					<a href="#" className={ nonFictionClass } onClick={ this.onSelect.bind(this, "non-fiction") }>NF</a>
				</div>
			)
			return (
				<td className="bookTextVariety">
					{ link }
				</td>
			)
		} else {
			if (this.props.book.text_variety && TextTypes["Varieties"]["TYPES"][this.props.book.text_variety]) {
				var textVariety = TextTypes["Varieties"]["TYPES"][this.props.book.text_variety].abbreviation;
			} else {
				var textVariety = "-";
			}
			var link = (
					<Glyphicon icon={ "pencil" } className="editIcon"/>
			)
			return (
				<td className="clickable editable" onClick={this.triggerEdit}>
					<span className="textVarietyDisplay">
						{ textVariety }
					</span>
					{ link }
				</td>
			)
		}
	}
	render() {
		if (this.props.displayMode && this.props.displayMode == "cell") {
			return this.renderCellDisplay()
		} else {
			return this.renderModalDisplay()
		}
	}

};

BookTextVariety.propTypes = StrictPropTypes({
	reset: PropTypes.func,
	book: PropTypes.object.isRequired,
	onSubmit: PropTypes.func,
	displayMode: PropTypes.string,
	onSelect: PropTypes.func,
	submitTextVariety: PropTypes.func,
});

module.exports = BookTextVariety;



// WEBPACK FOOTER //
// ./modules/components/reading/books/BookTextVariety.js